import { createContext } from "react";

const SubActivityContext = createContext({});

export default SubActivityContext;
